const commonActions = {
    SET_ALERT: 'SET_ALERT',
    SET_BUTTON_LOADER: 'SET_BUTTON_LOADER',
    SET_SHOW_MODAL: 'SET_SHOW_MODAL',
    SET_SHOW_BULK_UPLOAD_MODAL: 'SET_SHOW_BULK_UPLOAD_MODAL',
    SET_PAGE_LOADER: 'SET_PAGE_LOADER',
    SET_PAGINATION_VALUE: 'SET_PAGINATION_VALUE',
    SET_TABLE_LOADER:"SET_TABLE_LOADER"
};

export default commonActions;